import { GenericLink } from "../../link";
import { unstable_Typography } from "../../typography";
import * as Slate from "../slate";
function copyNodes(nodes, context) {
  return nodes.flatMap((d) => copyNode(d));
  function copyNode(descendant) {
    if (Slate.isInline(descendant)) {
      const { children, ...rest } = descendant;
      return {
        ...Slate.isLink(descendant) ? copyLinkData(descendant) : rest,
        children: children.map(copyNode)
      };
    }
    if (Slate.Text.isText(descendant)) {
      return copyTypographyData(descendant);
    }
    return {
      ...descendant,
      children: descendant.children.map(copyNode)
    };
  }
  function copyLinkData(element) {
    if (element.link == null)
      return element;
    const { link, ...rest } = element;
    return {
      ...rest,
      link: GenericLink().copyData(link, context) ?? null
    };
  }
  function copyTypographyData({ typography, ...text }) {
    return {
      ...text,
      ...typography == null ? {} : {
        typography: unstable_Typography().copyData(typography, context)
      }
    };
  }
}
export {
  copyNodes
};
//# sourceMappingURL=copy.js.map